<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="5"></app-admin-navigation>
    </div>

    <!-- Electricity -->
    <div class="w-full border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.file_extraction' |
                    transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <div class="m-5 flex flex-wrap gap-2 justify-between items-center">
            <div class="flex flex-col gap-2">
                <div class="w-[300px] h-[50px]">
                    @if(!isUploading) {
                    <app-custom-button buttonText="{{ 'shared.pages.file_upload' | transloco}}"
                        leadingIcon="assets/icons/upload.svg" (buttonClick)="triggerFileInput()"
                        borderColor="border-primary"></app-custom-button>}
                    @else {
                    <div
                        class="flex items-center justify-center gap-2 border border-primary rounded-[16px] px-4 py-2 bg-primary-50 text-primary text-sm font-medium">
                        <svg class="w-5 h-5 animate-spin text-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"></path>
                        </svg>
                        <span>{{ 'shared.file_upload.uploading' | transloco }}</span>
                    </div>
                    }
                    <input type="file" #fileInput accept=".pdf" (change)="onFileSelected($event)" hidden>
                </div>
            </div>
        </div>

        <!-- History Table -->
        <div class="w-full flex flex-col gap-2 p-5">
            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen block min-h-[300px] h-full overflow-y-auto rounded-[16px]">
                <table class="table w-full">
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">#</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.date' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.status' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal text-end">{{
                                'archive.overview.action' |
                                transloco }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of extractionHistory; let i = index">
                            <tr [ngClass]="[expandedRow === i ? 'bg-primary text-white hover:bg-primary-1200' : 'hover:bg-neutral-200']"
                                class="max-h-[50px] hover:cursor-pointer" (click)="toggleDetails(i)">
                                <td class="border-b border-border px-4 py-4">{{ i + 1 }}</td>
                                <td class="border-b border-border px-4 py-4">{{ item.created_at | isoDateTime }}
                                </td>
                                <td class="border-b border-border px-4 py-4">{{
                                    getExternalStatusTranslocoKey(item.status) | transloco }}
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 items-center justify-end">
                                        <button>
                                            <p class="text-primary hover:underline" *ngIf="expandedRow !== i">
                                                {{ 'invoice.view_details' | transloco }}</p>

                                            <p class="text-white hover:underline" *ngIf="expandedRow === i">
                                                {{ 'invoice.close_details' | transloco }}</p>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="expandedRow === i">
                                <td colspan="6" class="border-b border-border px-4 py-4" @expandRow>
                                    <app-expanded-extraction-history [historyItem]="item" [toast]="toast"
                                        [loadedEventLogs]="loadedEventLogs"></app-expanded-extraction-history>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="loadedExtractionHistory.length > 0 && !loadMoreHidden">
                            <td colspan="6">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadHistoryNewPage()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</div>